import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";

const FileUploadComponent = ({
  fileKey,
  selectedFiles,
  handleFileChoose,
  accept = ".xlsx,.xls",
  multiple = false,
}) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    handleFileChoose(files);
  };

  return (
    <Box sx={{ mb: 2, width: "100%" }}>
      <input
        key={fileKey} // This key will force re-render and reset the input
        ref={fileInputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleFileChange}
        style={{
          padding: "16px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          backgroundColor: "#fff",
          cursor: "pointer",
          fontSize: "14px",
          fontFamily: "inherit",
          width: "100%",
        }}
      />

      <Typography
        variant="caption"
        sx={{
          display: "block",
          mt: 0.5,
          color: "#666",
          fontSize: "12px",
        }}
      >
        *File Types Excel/CSV
      </Typography>
    </Box>
  );
};

export default FileUploadComponent;
